import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, homeFor } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function LinkedInCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) {
      return;
    }
    processed.current = true;
    const code = new URLSearchParams(window.location.hash.slice(1)).get("li_code");
    window.history.replaceState(null, "", "/auth/linkedin");
    api.post("/auth/linkedin/exchange", { code })
      .then(({ data }) => { setUser(data); nav(data.role_confirmed ? homeFor(data) : "/onboarding", { replace: true }); })
      .catch(() => { setUser(false); nav("/login?linkedin_error=expired", { replace: true }); });
  }, [nav, setUser]);

  return <div className="grid min-h-screen place-items-center text-muted-foreground" data-testid="linkedin-callback-loading">Signing you in with LinkedIn…</div>;
}

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) {
      return;
    }
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const post = (n) => api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        nav(data.role_confirmed ? homeFor(data) : "/onboarding", { replace: true });
      })
      .catch((e) => {
        const s = e?.response?.status;
        if ((!s || s >= 500) && n < 3) { setTimeout(() => post(n + 1), 2000 * (n + 1)); return; }
        setUser(false);
        nav("/login?google_error=1", { replace: true });
      });
    post(0);
  }, [location.hash, nav, setUser]);

  return <div className="grid min-h-screen place-items-center text-muted-foreground" data-testid="google-callback-loading">Signing you in with Google…</div>;
}
